import axios from '@/libs/api.request'
//发票列表
export const apiinvoiceList = data => {
    return axios.request({
      url: '/invoice/list',
      method: 'post',
      data
    })
  }
  //发票列表
  export const apiinvoiceUpload = data => {
    return axios.request({
      url: '/invoice/upload',
      method: 'post',
      data
    })
  }